<template>
    <div class="box mt-5">
        <div class="row">
            <div class="col-md-12 m-3">
                <h3> Additional Documents <ShowHideEye :showSection="showSection" @toggle="showSection = !showSection"/> </h3>
            </div>
        </div>
        <div class="row"  v-if="showSection">
            <div class="col-md-12">
                <form class="form wrap form--inline">
                    <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(33% - 1rem);">
                        <label for="name" class="fw-bold">Additional booking document</label>
                        <input id="file-upload" type="file" class="form-control" multiple accept="image/*,.pdf" @change="uploadDoc">
                    </div>
                    <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(33% - 1rem);">
                        <label for="document_detail" class="fw-bold">Document Detail</label>
                        <input id="document_detail" type="text" class="form-control" v-model="documentDetail">
                    </div>
                    <button class="button mt-1" type="button" v-on:click="addAdditionalDocuments" v-if="userRole == 1"><span>Add Documents</span></button>
                </form>
    
                <table class="table" cellspacing="0" cellpadding="0" >
                    <thead>
                        <tr>
                        <th>Document Name</th>
                        <th>Document Detail</th>
                        <th width="10%">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="booking.additional_documents.length > 0">
                            <tr  v-for="document of booking.additional_documents" :key="document.id">
                                <td>{{document.name}}</td>
                                <td>{{document.document_detail ? document.document_detail : '-' }}</td>
                                <td class="table-action">
                                <a class="nav-link dropdown-toggle icon icon--more me-3" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                    <li><a class="dropdown-item" href="javascript:void(0);" @click="emailToCustomer(document.id)">Email To Customer</a></li>
                                    <li><a class="dropdown-item" href="javascript:void(0);" @click="documentDownload(document.id, document.name)">Download</a></li>
                                </ul>
                                <a v-on:click="deleteAdditionalDocument(document.id)" class="icon icon--delete">Delete</a>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import ShowHideEye from '../ShowHideEye.vue'
export default {
    name: 'AdditionalDocuments',
    components: { ShowHideEye },
    props: {
        booking:Object  
    },
    created() {
        this.userRole
    },
    computed: {
        userRole() {
            let user_role = localStorage.getItem("user_role");
            if (user_role == 1) {
                this.showSection = true
            }
            return user_role
        },
    },
    data() {
        return {
            showSection:false,
            additionalDocument: [],
            documentDetail: '',
        }
    },
    methods: {
        uploadDoc(event) {
            this.additionalDocument = event.target.files;
        },
        addAdditionalDocuments() {
            this.$store.dispatch('setLoadStatus');
            const formData = new FormData();
            for (var i = 0; i < this.additionalDocument.length; i++ ){
                let file = this.additionalDocument[i];
                formData.append('files[' + i + ']', file);
            }
            formData.append('document_detail', this.documentDetail);

            fetch(this.$api + 'bookings/' + this.$route.params.id + '/additional-documents', {
                method: 'POST',
                body: formData,
                headers:{
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
            this.errors = response.errors
            if(response.success) {
                this.booking.additional_documents = response.data;
                this.$notify({
                    type: 'success',
                    title: response.message
                });
            } else {
                this.$notify({
                    type: 'error',
                    title: response.message
                });
            }
            this.$store.dispatch('setLoadStatus')
            });
        },
        deleteAdditionalDocument(id) {
            this.$dialog
            .confirm('Are you sure you want to delete document?')
            .then(() => {
                this.$store.dispatch('setLoadStatus')
                fetch(this.$api + 'bookings/' + id + '/additional-documents/delete', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then(res => res.json())
                .then(response => {
                    this.errors = response.errors
                    if(response.success == true) {
                        this.booking.additional_documents = response.data;
                        this.$notify({
                            type: 'success',
                            title: response.message
                        })
                    } else if (response.errors) {
                        this.$notify({
                            type: 'error',
                            title: response.message
                        })
                    } else {
                        this.$notify({
                            type: 'error',
                            title: response.Error
                        })
                    }
                    this.$store.dispatch('setLoadStatus')
                });
            })
            .catch(() => {
                console.log('Clicked on cancel');
            });
        },
        emailToCustomer(documentId) {
            this.$dialog
            .confirm('Are you sure you want to email document to customer?')
            .then(() => {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'bookings/' + this.$route.params.id + '/additional-document-email/' + documentId, {
                headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                if(response.success) {
                this.$notify({
                    type: 'success',
                    title: response.message
                });
                } else {
                this.$notify({
                    type: 'error',
                    title: response.message
                });
                }
                this.$store.dispatch('setLoadStatus')
            })
            })
            .catch(() => {
            console.log('Clicked on cancel');
            });
        },
        documentDownload(id, filename) {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'bookings/' + id + '/additional-documents/download' , {
            headers: {
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
            }
            })
            .then((res) => {
            if(res.status === 200) {
                res.blob().then(response => {
                const _url = window.URL.createObjectURL(response)
                const link = document.createElement('a')
                link.href = _url
                link.setAttribute('download', filename)
                document.body.appendChild(link)
                link.click();
                })
            }else {
                this.$notify({
                type: 'error',
                title: 'File not found'
                });
            }
            this.$store.dispatch('setLoadStatus')
            })
        }
    }
}
</script>

<style lang="scss" scoped>

</style>